'use client'

import { cn } from '@/util/cn'
import { overlayBlock } from '../../../presentation/blocks'
import { useCutOut } from '../cut-out-context'

/**
 * Legacy cut-out/tools/magic.tsx. The whole tool is a click target laid over
 * the canvas — one click runs background removal on the current edit canvas.
 */
const Magic = () => {
    const { handleMagicWand } = useCutOut()

    return (
        <div className={cn(overlayBlock, 'cursor-pointer select-none')}>
            <div data-testid="magic-wand-target" className="h-full w-full" onClick={handleMagicWand} />
        </div>
    )
}

export default Magic
